'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; // import Autosuggest from 'react-autosuggest'

// import { connect } from 'react-redux'

// import {Row, Col} from 'react-flexbox-grid'
// import * as searchActions from 'redux/modules/search'

// import format from '../../helpers/format'
// import Loader from 'react-loader'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./Home.css');

// @connect(
//   state => ({
//     signupsubmit: state.signupsubmit.result
//   }),
//   searchActions)
var Home = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home(props) {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this, props));

    _this.state = {
      // openModal: true,
    };
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
    // const signupsubmit = this.props.signupsubmit ?
    //   this.props.signupsubmit :
    //   false
    // this.props.signupsubmitChange(signupsubmit)


    // clickCloseModal = () =>{
    //   this.props.signupsubmitChange(true)
    // }

  }, {
    key: 'render',
    value: function render() {
      // IMAGES
      var aysCircleLogo = require('../../../static/images/icn-ays.png');
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      var equileapLogo = require('../../../static/images/equileap-logo.png');
      var subscoreAIcon = require('../../../static/images/GEF-icons-gender-balance-peer-rank.svg');
      var subscoreBIcon = require('../../../static/images/GEF-icons-gender-equality-peer-rank.svg');
      var subscoreCIcon = require('../../../static/images/GEF-icons-gender-equality-policies-rank.svg');
      var subscoreDIcon = require('../../../static/images/GEF-icons-gender-equality-policies-score.svg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner-wrapper-mobile' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'banner-wrapper' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-title' },
                  'You have the power to invest in gender equality'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-btn-wrap' },
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.routes.clean,
                      bigbutton: true,
                      title: 'Top-scoring funds'
                    },
                    _react2.default.createElement(
                      'div',
                      null,
                      'Top-scoring funds',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  'Search for mutual funds or ETFs from your 401(k), retirement plan, or personal portfolio'
                ),
                _react2.default.createElement(_components.AutocompleteSearch, null),
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-btn-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'logo-tagline' },
                    'A project of'
                  ),
                  _react2.default.createElement(
                    _components.Link,
                    { to: _config2.default.links.ays, title: 'As You Sow' },
                    _react2.default.createElement('img', {
                      styleName: 'logo-ays',
                      src: aysLogo,
                      alt: 'As You Sow'
                    }),
                    _react2.default.createElement(
                      _components.SrOnly,
                      null,
                      'As You Sow'
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'x-lede' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-lede-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'media-col' },
              _react2.default.createElement(
                'div',
                { styleName: 'media-icon-title-wrap' },
                _react2.default.createElement('img', {
                  styleName: 'media-icon',
                  alt: 'From As You Sow',
                  src: aysCircleLogo
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'media-title-wrap' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'media-title' },
                    'Introducing: Gender Equality Funds'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'media-subtitle' },
                    'From As You Sow'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'media-react-player-wrap' },
                _react2.default.createElement(_reactPlayer2.default, {
                  url: 'https://vimeo.com/367115693',
                  volume: 0.5
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-title' },
              'Invest your values'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-subtitle-2' },
              _react2.default.createElement(
                'strong',
                null,
                'Individual and institutional investors can align their actions with their values, and take responsibility for the investments they own.'
              ),
              ' Aligning investments with values requires that you know what you own \u2014 but if you\u2019re invested through mutual funds, it has been nearly impossible to know what individual companies you own. That\u2019s changed with As You Sow\u2019s ',
              _react2.default.createElement(
                'strong',
                null,
                'Gender Equality Funds'
              ),
              '.  Now, you can harness your personal economic power to confront big business.'
            )
          )
        ),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement(
          'div',
          { styleName: 'x-lede' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-lede-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'lower-lede-cols' },
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Gender Equality Funds'
                  ),
                  ' is powered by the ',
                  _react2.default.createElement(
                    _components.Link,
                    {
                      to: _config2.default.links.equileapResearch,
                      title: 'Equileap reports - Equileap',
                      xstrong: true
                    },
                    'Equileap Gender Equality Scorecard'
                  ),
                  ', inspired by the UN\u2019s Women Empowerment Principles. The Equileap Gender Equality Scorecard scores companies based on 19 criteria, including gender balance across the workforce, the gender pay gap, paid parental leave, and anti-sexual harassment policies.'
                ),
                _react2.default.createElement('img', {
                  styleName: 'logo-equileap',
                  src: equileapLogo,
                  alt: 'As You Sow'
                })
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col-2' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: subscoreAIcon,
                      alt: 'Gender balance in leadership and workforce',
                      styleName: 'inline-icon-sm'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      'Gender balance in leadership and workforce'
                    )
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '1 - Board of Directors'
                    ),
                    ' - Percentage of male and female Board of Directors as a proportion of the total number.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '2 - Executives'
                    ),
                    ' - Percentage of male and female Executives as a percentage of the total number.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '3 - Senior Management'
                    ),
                    ' - Percentage of male and female senior managers as a percentage of total.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '4 - Workforce'
                    ),
                    ' - Percentage of male and female employees as a percentage of total.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '5 - Promotion and Career Development Opportunities'
                    ),
                    ' - Ratio of each gender in Senior Management compared to ratio of each gender in the Workforce.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col-2' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: subscoreBIcon,
                      alt: 'Equal compensation and work life balance',
                      styleName: 'inline-icon-sm'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      'Equal compensation and work life balance'
                    )
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '6 - Living Wage'
                    ),
                    ' - Commitment to ensure payment of a living wage to all employees, even in those countries that do not legally require a minimum wage or where minimum wage is not a living wage.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '7 - Gender Pay Gap'
                    ),
                    ' - Commitment to provide comparable wages for comparable work and to close the gender pay gap.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '8 - Parental Leave'
                    ),
                    ' - Paid leave programs (at least 2/3 paid) for child care to both primary or secondary carers globally or at least in the country of incorporation.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '9 - Flexible Work Options'
                    ),
                    ' - Option for employees to control and/or vary the start and end times of the work day and/or vary the location from which employees work.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col-2' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: subscoreCIcon,
                      alt: 'Policies promoting gender equality',
                      styleName: 'inline-icon-sm'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      'Policies promoting gender equality'
                    )
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '10 - Training and Career Development'
                    ),
                    ' - Commitment to ensure equal access to training and career development to both men and women.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '11 - Recruitment Strategy'
                    ),
                    ' - Commitment to ensure non-discrimination against any type of demographic group and equal opportunities to ensure gender parity.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '12 - Freedom from Violence, Abuse and Sexual Harassment'
                    ),
                    ' - Prohibits all forms of violence in the work place, including verbal, physical and sexual harassment.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '13 - Safety at Work'
                    ),
                    ' - Commitment to the safety of employees in the workplace, in travel to and from the workplace, and on company related business, and ensure the safety of vendors in the workplace.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '14 - Human Rights'
                    ),
                    ' - Commitment to ensure the protection of the rights of all people it works with including employees\u2019 rights to participate in legal, civic and political affairs.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '15 - Social Supply Chain'
                    ),
                    ' - Commitment to reduce social risks in its supply chain such as forbid business related activities that condone, support, or otherwise participate in trafficking, including for labor or sexual exploitation.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '16 - Supplier Diversity'
                    ),
                    ' - Commitment to ensure diversity in the supply chain, including support for women owned businesses in the supply chain.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '17 - Employee Protection'
                    ),
                    ' - Systems and policies for the reporting of internal ethical compliance complaints without retaliation or retribution, including but not limited to access to confidential third-party ethics hotlines or systems for confidential written complaints.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'lower-lede-col-2' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'small-title' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'icon-label-wrap' },
                    _react2.default.createElement('img', {
                      src: subscoreDIcon,
                      alt: 'Commitment, transparency, and accountability',
                      styleName: 'inline-icon-sm'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'icon-label' },
                      'Commitment, transparency, and accountability'
                    )
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '18 - Commitment to Women\u2019s Empowerment'
                    ),
                    ' - Recognition and commitment to ensuring women\u2019s empowerment in the workplace.'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      '19 - Audit'
                    ),
                    ' - Undertaken and awarded an independent gender audit certificate by an Equileap recognized body.'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null),
        _react2.default.createElement(_components.BenchmarkGrid, null),
        _react2.default.createElement(_components.TargetDateGrid, null),
        _react2.default.createElement(_components.FamilyGrid, null),
        _react2.default.createElement(
          'div',
          { styleName: 'x-401k' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-401k-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-401k-title' },
              'Tracking trillions in investments'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-401k-info-photo' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-401k-info' },
                _react2.default.createElement(
                  'p',
                  { styleName: 'x-401k-top' },
                  'Gender lens investing isn\'t just a moral question. Research shows gender diverse companies tend to have better returns and lower risk.'
                ),
                _react2.default.createElement(
                  'blockquote',
                  null,
                  'Equal pay and, more broadly, equal opportunities at work are powerful levers to grow global prosperity: they have the potential to take millions of women and their families out of poverty and move us closer to achieving the Sustainable Development Goals by 2030, as defined by the United Nations.',
                  _react2.default.createElement('br', null),
                  '\u2013 Equileap, Gender Equality Global Report and Ranking (2017)'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Discover which funds are investing in the companies that lead the field in terms of gender equality. A growing body of evidence correlates various gender-lens investing criteria with higher financial performance and lower investment risk.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Use ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    'Gender Equality Funds'
                  ),
                  ' to search and compare mutual funds based on their gender-lens score and financial performance. You can use our database to find sustainable investment options that meet your specific needs.'
                )
              )
            ),
            _react2.default.createElement(_components.AboutBanner, null)
          )
        ),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return Home;
}(_react.Component), _class2.propTypes = {
  // signupsubmit: PropTypes.bool
}, _temp)) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1305
// module chunks = 0